export default __webpack_public_path__ + "static/media/logo-light.d4394290.png";